const createPublicKeyProviderPlugin = ({ publicKeysCacheAtom }) => {
    const onLock = () => publicKeysCacheAtom.set(undefined);
    return { onLock };
};
const publicKeyProviderPluginDefinition = {
    id: 'publicKeyProviderPlugin',
    type: 'plugin',
    factory: createPublicKeyProviderPlugin,
    dependencies: ['publicKeysCacheAtom'],
};
export default publicKeyProviderPluginDefinition;
